// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-1pP88";
var _3 = "label-2ZYDA";
export { _1 as "__esModule", _2 as "root", _3 as "label" }
export default { "__esModule": _1, "root": _2, "label": _3 }
